import { LT_DEBT_DATA_RECEIVED, LT_DEBT_UNLOADED, LT_DEBT_SAVED, LT_DEBT_DELETED } from './types';
import api from 'api';

export const debtLTDataReceived = (data) => ({
  type: LT_DEBT_DATA_RECEIVED,
  data
})

export const debtLTDataUnload = () => ({
  type: LT_DEBT_UNLOADED
})

export const debtSaved = (data) => ({
  type: LT_DEBT_SAVED,
  data
})

export const debtDeleted = (data) => ({
  type: LT_DEBT_DELETED,
  data
})

export const unloadDebt = () => dispatch => {
  dispatch(debtLTDataUnload())
}

export const postDebt = data => dispatch =>
  api.bmc.debts.postDebt(data).then( debt =>{
  dispatch(debtSaved(debt))
})

export const deleteDebt = data => dispatch =>
  api.bmc.debts.deleteDebt(data).then( debt =>{
  dispatch(debtDeleted(data))
})

// TODO: catch with user logout and user data not recived
export const getDebts = (view = false) => (dispatch) =>
  api.bmc.debts.getDebts(view?'viewTY':'').then( debts => {
  dispatch(debtLTDataReceived(debts))
});
